import { ulid } from 'ulid';
import type { LimitPolicyViewModel } from '@/graphql/generated';

type LimitPolicyCloneInput = Pick<LimitPolicyViewModel,
  | 'name'
  | 'priority'
  | 'isActive'
  | 'scenarioId'     // Foreign key - preserved (the policy uses the same scenario)
  | 'limitId'        // Foreign key - preserved (the policy uses the same limit)
  | 'billingCycleId' // Lookup - preserved
> & {
  scenarioLabel?: string | null;  // For autocomplete display
  limitLabel?: string | null;     // For autocomplete display
};

export interface ClonedLimitPolicyData {
  limitPolicyId: string;
  name: string;
  priority: number;
  isActive: boolean;
  scenarioId?: string | null;
  scenarioLabel?: string | null;  // For autocomplete display
  limitId: string;
  limitLabel?: string | null;     // For autocomplete display
  billingCycleId: number;
}

/**
 * Clone a LimitPolicy entity
 * 
 * - limitPolicyId: NEW (regenerated)
 * - facilityId: Handled server-side (not included in CreateLimitPolicyInput)
 * - scenarioId: PRESERVED (foreign key - the policy references the same scenario)
 * - limitId: PRESERVED (foreign key - the policy references the same limit)
 * - billingCycleId: PRESERVED (lookup reference)
 * - All other fields: COPIED as-is
 */
export function cloneLimitPolicy(source: LimitPolicyCloneInput): ClonedLimitPolicyData {
  return {
    limitPolicyId: ulid(),
    name: `${source.name} (Copy)`,
    scenarioId: source.scenarioId,
    scenarioLabel: source.scenarioLabel,
    limitId: source.limitId,
    limitLabel: source.limitLabel,
    billingCycleId: source.billingCycleId,
    priority: source.priority,
    isActive: source.isActive,
  };
}
